// 1. Ajoute ces imports en TOUT PREMIER
import { Buffer } from 'buffer'
import process from 'process'
// Ensuite tes imports habituels
import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './redux/store'

// 2. Définis-les globalement pour que @react-pdf/renderer puisse les trouver
window.Buffer = window.Buffer || Buffer
window.process = window.process || process

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)

reportWebVitals()
